import { Button } from "@remo-co/ui-core/src/components/Button";
import { Card } from "@remo-co/ui-core/src/components/Card";
import { Container } from "@remo-co/ui-core/src/components/Container";
import { Divider } from "@remo-co/ui-core/src/components/Divider";
import { Grid } from "@remo-co/ui-core/src/components/Grid";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { OpenInNew } from "@remo-co/ui-core/src/icons/OpenInNew";
import classNames from "classnames";
import { useI18n } from "i18n";
import { CreateEventButton } from "modules/eventForm/components";
import BookIcon from "../../assets/book.svg";
import { useStyles } from "./styles";

export const CreateFirstEventCard = () => {
  const { t } = useI18n(["event", "menu", "url"]);
  const styles = useStyles();

  return (
    <Card className={styles.card}>
      <Container className={styles.header}>
        <Container className={styles.textContainer}>
          <Typography variant="h3" className={styles.title}>
            {t("event:noevents.created")}
          </Typography>
          <Typography variant="h5" className={styles.subtitle}>
            {t("event:create.encourage")}
          </Typography>
        </Container>
        <CreateEventButton
          id="my-event_primary-cta-create-event"
          label={t("event:create.my.first.event")}
          className={styles.createFirstEventButton}
        />
      </Container>
      <Divider className={styles.divider} />
      <Container className={styles.supportContainer}>
        <Typography variant="h5" className={styles.supportTitle}>
          <img
            src={BookIcon}
            alt={t("event:remo.support")}
            className={styles.supportIcon}
          />
          {t("event:remo.support")}
        </Typography>
        <Typography variant="body1" className={styles.supportSubtitle}>
          {t("event:remo.support.description")}
        </Typography>
      </Container>
      <Grid container className={styles.grid}>
        <Grid item lg={3} className={styles.buttonGrid}>
          <Button<"a">
            variant="secondary"
            size="sm"
            aria-label={t("event:contact.support")}
            data-testid="contact.support"
            target="_blank"
            rel="noreferrer"
            href={t("url:contact.support.mailto")}
            className={classNames(styles.linkText, styles.support)}
          >
            {t("event:contact.support")}
          </Button>
          <Button<"a">
            variant="secondary"
            size="sm"
            aria-label={t("event:view.remo.helpdesk")}
            data-testid="view.remo.helpdesk"
            className={classNames(
              styles.linkText,
              styles.liveSupportLoungeButton,
              styles.helpDesk,
            )}
            target="_blank"
            rel="noreferrer"
            href={t("url:remo.helpdesk")}
          >
            {t("event:view.remo.helpdesk")}
          </Button>
        </Grid>
        <Grid item lg={3} className={styles.linkGrid}>
          <Button<"a">
            variant="text"
            color="blue"
            size="sm"
            aria-label={t("event:getting.started.with.remo")}
            data-testid="getting.started.with.remo"
            target="_blank"
            rel="noreferrer"
            href={t("url:getting.started")}
            className={styles.linkText}
          >
            {t("event:getting.started.with.remo")}
            <OpenInNew className={styles.linkIcon} />
          </Button>
          <Button<"a">
            variant="text"
            color="blue"
            size="sm"
            aria-label={t("event:how.to.create.an.event")}
            data-testid="how.to.create.an.event"
            target="_blank"
            rel="noreferrer"
            href={t("url:how.to.create.event")}
            className={styles.linkText}
          >
            {t("event:how.to.create.an.event")}
            <OpenInNew className={styles.linkIcon} />
          </Button>
          <Button<"a">
            variant="text"
            color="blue"
            size="sm"
            aria-label={t("event:view.remo.academy")}
            data-testid="view.remo.academy"
            target="_blank"
            rel="noreferrer"
            href={t("url:academy")}
            className={styles.linkText}
          >
            {t("event:view.remo.academy")}
            <OpenInNew className={styles.linkIcon} />
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};
